import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { testimonials } from "@/mocks/testimonials";

export default function Voices() {
  return (
    <section className="w-full bg-background-100/60 border-y border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="投稿人怎么说"
            title="被认真对待，是投稿人最直接的感受"
            desc="以下反馈来自投稿人与常驻读者的自愿留言，隐私信息已做处理。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {testimonials.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <figure className="h-full flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/80">
                <span className="w-8 h-8 flex items-center justify-center text-accent-500">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </span>
                <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">
                  {item.content}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <span className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <i className={`${item.avatar} text-lg`}></i>
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">
                      {item.name}
                    </span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}